/* src/app/candidate/call-log/call-log.component.scss */
.candidateCallLogView {
  height: 95px;
  overflow: auto !important;
}
.error_message {
  color: red;
}
.notesContainer {
  overflow-y: auto;
  min-height: 130px;
  height: 100px;
  max-height: 200px;
}
.testH {
  height: 200px;
  padding-right: 15px;
}
.tr-n {
  right: 0px;
  bottom: 7px;
}
::-webkit-scrollbar {
  width: 4px;
}
:hover::-webkit-scrollbar {
  width: 4px;
  display: block;
  transition: all 0.4s;
}
::-webkit-scrollbar-track {
  background: white !important;
}
::-webkit-scrollbar-thumb {
  background: #CCCCCC;
}
::-webkit-scrollbar-thumb:hover {
  background: #CCCCCC;
}
.SuccessBoxed {
  width: 100%;
  height: 50px;
  border-radius: 2px;
  border: dashed 1px #2e93a1;
  background-color: #d5e9ec;
  color: #206c79;
}
.wc-form-control-activity {
  width: 280px;
  height: 36px;
  border-radius: 2px;
  border: solid 1px #b3b3b3;
  background-color: #ffffff;
}
.tr-x {
  right: 0;
}
/*# sourceMappingURL=call-log.component-F376RUAQ.css.map */
